export default function formatTime(value) {
  return !value ? null : value.format(value.minutes() === 0 ? 'hA' : 'h:mA');
}
